<template>
  <div
    ref="cardRef"
    role="listitem"
    :class="{card: true, unread: !isRead}"
    :data-channel="(notification as any).channel"
    :data-type="notification.type"
    :data-group="notification.group"
    :data-date="notification.add_date"
    :data-id="notification.id"
  >


  <div class="hidden">
    {{ notification }}
  </div>

    <div class="wrapper">

      <div class="unread-dot" v-if="!isRead"></div>


      <div class="avatar">
        <img loading="lazy" 
          v-if="prepared.img" 
          :src="prepared.img" 
          class="avatar-img"
        />
        <i v-else class="icon-bell" aria-hidden="true"></i>
      </div>

      <div class="body">
        <NotificationV2NotificationCardMessage :notification="notification" />
      </div>

      
      <div         
        class="remove-btn" 
        @click.stop.prevent="removeNotification"
        >
        <i class="icon-close-thin" aria-label="Remove notification"></i>
      </div>

    </div>



      <div 
        class="template" 
        v-if="showTemplate && template && [NotificationTemplate.Diary, NotificationTemplate.Problem, NotificationTemplate.Solution, NotificationTemplate.Week, NotificationTemplate.Comment, NotificationTemplate.Blog].includes(template)">
        <NotificationV2CardsBlog v-if="template === NotificationTemplate.Blog" :notification="notification as any" />
        <NotificationV2CardsDiary v-if="template === NotificationTemplate.Diary" :notification="notification as any" />
        <!-- <NotificationV2CardsReview v-if="template === 'review'" :notification="notification" /> -->
        <NotificationV2CardsProblem v-if="template === NotificationTemplate.Problem" :notification="notification as any" />
        <NotificationV2CardsSolution v-if="template === NotificationTemplate.Solution" :notification="notification as any" />
        <!-- <NotificationV2CardsVideo v-if="template === 'video'" :notification="notification" /> -->
        <NotificationV2CardsWeek v-if="template === NotificationTemplate.Week" :notification="notification as any" />
        <!-- <NotificationV2CardsUser v-if="template === 'user'" :notification="notification" /> -->
        <NotificationV2CardsComment v-if="template === NotificationTemplate.Comment" :notification="notification as any" />
      </div>


  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { NotificationItem, NotificationGroup } from '@/types/notification'
import { NotificationTemplate } from '@/types/notification'
import { useNotifications, useNotificationViewed } from '@/composables/useNotifications'



const props = defineProps<{ 
  notification: NotificationItem | NotificationGroup 
  showTemplate?: boolean
  channel?: string
}>()
const emit = defineEmits<{
  (e: 'remove', id: string, channel: string): void
}>()

const { cardRef, isRead } = useNotificationViewed(props.notification.is_read, props.notification, null, () => {
  props.notification.is_read = true
  emit('read:notification', props.notification)
})

const removeNotification = () => emit('remove', props.notification.id, (props.notification as any).channel || 'direct')

const template = computed(() => {
  return useNotifications().getTemplate((props.notification as any).type)
})

const prepared = computed(() => {
  let item = {
  img: (props.notification.contexts.item_user as any)?.avatar_little   
}
  return item
})

</script>

<style scoped>
.card{ 
  display:flex;
  align-items:center;
  flex-direction:column;

  padding:8px 12px;
  border-radius:8px;
  transition:background-color 1000ms ease,filter 1000ms ease;
}
.card.unread{ 
  /* background-color: var(--gd-background-color-green-2-transparent-light);  */
}


.avatar{ flex:0 0 32px; width:32px; height:32px; display:flex; align-items:center; justify-content:center; border-radius:50%; overflow:hidden; }
.avatar-img{ width:100%; height:100%; object-fit:cover; }
.avatar i{ font-size:20px; color:var(--accent); }


.body{ flex:1 1 auto; overflow:hidden;color:var(--un-text-color-gray);  }
.body :deep(.more-users-link), 
.body :deep(a){ 
  color:var(--un-text-color); 
}  

.meta{ flex-shrink:0; display:flex; flex-direction:column; align-items:flex-end; gap:4px; position:relative; }
.time{ font-size:10px; color:var(--un-text-color-gray-light); }
.dot{ width:8px; height:8px; border-radius:50%; background-color:var(--accent); display:block; }

.wrapper{ 
  position:relative;
  display:flex; align-items:center; gap:12px; width: 100%; }
.remove-btn{
  width:30px;
  height:30px;
  border-radius:50%;
  display:flex;
  align-items:center;
  justify-content:center;
  cursor:pointer;
  transition:background-color 200ms ease;
  line-height:1;
  flex-shrink:0;
}
.remove-btn:hover{ 

}

.template{
  border: 1.5px solid var(--un-background-color-gray-dark);
  border-radius:8px;
  padding:1rem;
  margin-top:0.5rem;
  width:100%;
}
.template:hover{ 
  background-color: #90909004;
}

/* Анимация просмотра */
.card.viewed-animation {
  animation: viewedPulse 2s ease-in-out;
}

@keyframes viewedPulse {
  0% {
    background-color: var(--gd-background-color-green-2-transparent-light);
  }
  50% {
    background-color: var(--accent-light);
  }
  100% {
    background-color: transparent;
  }
}

</style> 